import {styled} from '@mui/material';

const StyledAvailability = styled('div')`
	display: flex;
	flex-direction: column;
	gap: 4px;
	font-size: 14px;
	line-height: 20px;
`;

const StyledAvailabilityTitle = styled('span')`
	color: ${({theme}) => theme.palette.text.primary};
`;

const StyledLocationList = styled('ul')`
	margin: 0;
	padding: 0;
	list-style: none;
	color: ${({theme}) => theme.palette.text.secondary};
`;

export {StyledAvailability, StyledAvailabilityTitle, StyledLocationList};
